<template>
    <div :class="['relative', this.classList]">
        <input
            class="w-full p-2.5 pr-[35px] text-sm rounded-[5px] border-0 shadow outline-0 text-gray-900 placeholder:gdc-gray-600"
            type="text"
            @input="this.inputValue"
            :value="search"
            @focus="showSuggestions = true"
            :placeholder="this.placeholder"
        />

        <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" class="absolute top-[calc(50%-8.5px)] right-2"><g fill="none"><g fill="#8C8C8C"><path d="M1.02 7.12c0-3.37 2.73-6.1 6.1-6.1 3.37 0 6.1 2.73 6.1 6.1 0 3.37-2.73 6.1-6.1 6.1-3.37 0-6.1-2.73-6.1-6.1zM16.8 16.7c.27-.27.27-.7 0-.98l-4.14-4.13c1-1.24 1.58-2.8 1.58-4.48C14.24 3.2 11.04 0 7.12 0 3.2 0 0 3.2 0 7.12c0 3.93 3.2 7.12 7.12 7.12 1.7 0 3.24-.6 4.47-1.58l4.12 4.14c.27.27.7.28.98 0l.1-.1z"/></g></g></svg>

        <ul class="!list-none max-w-max min-w-full !p-0 border border-gdc-gray-400 text-sm bg-white absolute z-[1] overflow-y-hidden"
            v-show="this.showSuggestions && this.matches.length > 0">

            <li class="cursor-pointer !mb-0 hover:bg-gdc-gray-400 hover:text-white"
                v-for="(suggestion, index) in this.matches"
                :key="index"
                @click="setSuggestion(suggestion.id)">
                <span class="block text-sm p-1">{{ suggestion[label] }}</span>
            </li>

        </ul>
    </div>
</template>

<script type="text/javascript">
export default
{
    props: {

        classList: {
            type: String,
            default: 'relative',
        },

        value: {
            type: String
        },

        suggestions: {
            type: Array
        },

        placeholder: {
            type: String,
            default: 'Search...',
        },

        label: {
            type: String,
            default: 'title',
        },
    },
    computed: {

        /**
         * Search Value
         */
        search: {
            get()
            {
                return this.value
            },
            set(value)
            {
                this.$emit('input', value);
            },
        },

        matches()
        {
            return this.filterSuggestions();
        },
    },

    /**
     * Component Data
     *
     * @return {{showSuggestions: boolean}}
     */
    data()
    {
        return {
            showSuggestions: true,
        };
    },

    /**
     * Add a click event to check if we need to hide the suggestions
     */
    mounted()
    {
        document.addEventListener('click', (e) =>
        {
            if (!this.$el.contains(e.target)) {
                this.showSuggestions = false;
            }
        });
    },

    methods: {

        /**
         * Set Search Text
         *
         * @param event
         */
        inputValue(event)
        {
            event.preventDefault();
            this.search = event.target.value
        },

        /**
         * Filter suggestions
         *
         * @return {*[]}
         */
        filterSuggestions()
        {
            if (!this.search)
            {
                return [];
            }

            if (!this.showSuggestions)
            {
                this.showSuggestions = true;
                return [];
            }

            // Filter out records that don't contains this.search
            let results = this.suggestions.filter((suggestion) =>
                suggestion[this.label].toLowerCase().includes(this.search.toLowerCase())
            );

            return results.sort((a, b) =>
            {
                // Sort by the record that has this.search closest to the start of this.label
                return a[this.label].toLowerCase().indexOf(this.search.toLowerCase()) <
                b[this.label].toLowerCase().indexOf(this.search.toLowerCase())
                    ? -1
                    : 1;
            });
        },

        /**
         * Set Selected suggestion's id and clear autocomplete
         *
         * @param id
         */
        setSuggestion(id)
        {
            let selected = this.suggestions.find((suggestion) => suggestion.id === id);

            this.search = selected[this.label];

            this.showSuggestions = false;
        },
    },
};
</script>
